import React, { useEffect, useRef, type FC } from 'react';
import Showdown from 'showdown';
import { sendDetailView } from '../../../../utils/recombee/client';
import type { ContentPostProps } from './types';

const ContentPost: FC<ContentPostProps> = ({ postId, content }) => {
    const wrapper = useRef(null);
    const convertor = new Showdown.Converter({
        disableForced4SpacesIndentedSublists: true,
        openLinksInNewWindow: true,
    });

    useEffect(() => {
        if (wrapper) {
            wrapper.current.firstChild.className = 'first-letter';
            // @ts-ignore
            sendDetailView(postId);
        }
    }, []);

    return (
        <div className="max-w-5xl mx-auto sm:px-4">
            <div className="flex flex-wrap justify-center">
                <div className="md:w-3/4 pr-4 pl-4">
                    <div
                        ref={wrapper}
                        className="post-content-wrapper"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                        dangerouslySetInnerHTML={{
                            __html: convertor.makeHtml(content),
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ContentPost;
